class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.onDesktopMediaChange = this.onDesktopMediaChange.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.desktopMediaQuery.addEventListener('change', this.onDesktopMediaChange);
    this.onDesktopMediaChange(this.desktopMediaQuery);
  }

  disconnectedCallback() {
    this.desktopMediaQuery.removeEventListener('change', this.onDesktopMediaChange);
    this.removeHoverListeners();
  }

  onDesktopMediaChange(event) {
    if (event.matches) {
      this.addHoverListeners();
      return;
    }

    this.removeHoverListeners();
    this.close();
  }

  addHoverListeners() {
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
  }

  removeHoverListeners() {
    this.mainDetailsToggle.removeEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.onMouseLeave);
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
